import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {JobState} from "./JobState";
import {
	JOB_AGENT_UPDATED,
	JOB_CREATED,
	JOB_EVENTS_FETCHED,
	JOB_FETCHED,
	JOB_STATUS_UPDATED,
	JOB_UPDATED,
	JOB_WATCHERS_UPDATED
} from "../../action/job/actionType";
import {JOB_TAGS_FETCHED, TAGS_SET_TO_JOB} from "../../action/tag/actionType";
import _ = require("underscore");

/**
 * Initial state for jobs.
 */
const initState: JobState = {
	events: none,
	tags: none,
	jobsMap: {}
};

const reducer = handleActions({
	[JOB_CREATED]: (state: JobState, action: Action<any>): JobState => { //TODO: There is a bug with typings here. It is present only if action contains payload
		return {
			...state,
			jobsMap: {
				...state.jobsMap,
				[action.payload.job.referenceNumber]: action.payload.job,
				[action.payload.job.id]: action.payload.job
			}
		};
	},
	[JOB_FETCHED]: (state: JobState, action: Action<JOB_FETCHED>): JobState => {
		return {
			...state,
			jobsMap: {
				...state.jobsMap,
				[action.payload.job.referenceNumber]: action.payload.job,
				[action.payload.job.id]: action.payload.job
			}
		}
	},
	[JOB_UPDATED]: (state: JobState, action: Action<JOB_UPDATED>): JobState => {
		return {
			...state,
			jobsMap: {
				...state.jobsMap,
				[action.payload.job.referenceNumber]: action.payload.job,
				[action.payload.job.id]: action.payload.job
			}
		};
	},
	[JOB_STATUS_UPDATED]: (state: JobState, action: Action<JOB_STATUS_UPDATED>): JobState => {
		const job = state.jobsMap[action.payload.jobId];
		const jobsMap = {...state.jobsMap};
		if (job) {
			const updatedJob = job.copy({statusId: action.payload.statusId});
			jobsMap[updatedJob.referenceNumber] = updatedJob;
			jobsMap[updatedJob.id] = updatedJob;
		}
		return {...state, jobsMap};
	},
	[JOB_EVENTS_FETCHED]: (state: JobState, action: Action<JOB_EVENTS_FETCHED>): JobState => {
		const events = state.events.getOrElse([]).filter(event => event.jobId != action.payload.jobId);
		return {...state, events: option(events.concat(action.payload.events))};
	},
	[JOB_TAGS_FETCHED]: (state: JobState, action: Action<JOB_TAGS_FETCHED>): JobState => {
		return {...state, tags: option(action.payload.tags)}
	},
	[TAGS_SET_TO_JOB]: (state: JobState, action: Action<TAGS_SET_TO_JOB>): JobState => {
		const job = state.jobsMap[action.payload.jobId];
		const jobsMap = {...state.jobsMap};
		if (job) {
			const updatedJob = job.copy({tags: action.payload.tags});
			jobsMap[updatedJob.referenceNumber] = updatedJob;
			jobsMap[updatedJob.id] = updatedJob;
		}
		const tags = _.unique(state.tags.getOrElse([]).concat(action.payload.tags), (item) => item.name);
		return {...state, tags: option(tags), jobsMap}
	},
	[JOB_AGENT_UPDATED]: (state: JobState, action: Action<JOB_AGENT_UPDATED>): JobState => {
		const job = state.jobsMap[action.payload.jobId];
		const jobsMap = {...state.jobsMap};
		if (job) {
			const updatedJob = job.copy({agentId: action.payload.agentId});
			jobsMap[updatedJob.referenceNumber] = updatedJob;
			jobsMap[updatedJob.id] = updatedJob;
		}
		return {...state, jobsMap};
	},
	[JOB_WATCHERS_UPDATED]: (state: JobState, action: Action<JOB_WATCHERS_UPDATED>): JobState => {
		const job = state.jobsMap[action.payload.jobId];
		const jobsMap = {...state.jobsMap};
		if (job) {
			const updatedJob = job.copy({watchers: action.payload.watchers});
			jobsMap[updatedJob.referenceNumber] = updatedJob;
			jobsMap[updatedJob.id] = updatedJob;
		}
		return {...state, jobsMap};
	},
}, initState);

export default reducer;